import { types } from 'mobx-state-tree';
import { forEach } from 'lodash';

const Filters = types
  .model('filters', {
    profitType: 1,
    minPrice: types.maybe(types.number),
    maxPrice: types.maybe(types.number),
    minProfit: types.maybe(types.number),
    maxProfit: types.maybe(types.number),
  })
  .views(self => ({
    get isFiltered() {
      return self.minPrice !== null || self.maxPrice !== null || self.minProfit !== null || self.maxProfit !== null;
    },
    get getFiltersAsArray() {
      const filtersArray = [];
      forEach(self, (val, key) => {
        if (key !== 'profitType' && val) {
          filtersArray.push({ key, val });
        }
      });
      return filtersArray;
    },
    get getAllFiltersAsObject() {
      const filtersObj = {};
      forEach(self, (val, key) => {
        if (val!==null) {
          filtersObj[key] = val;
        }
      });
      if(self.isFiltered) {
        filtersObj.isFiltered = self.isFiltered;
      }
      return filtersObj;
    }
  }))
  .actions(self => {
    // const afterCreate = () => {
    //   onSnapshot(self, ({ minPrice, maxPrice, minProfit, maxProfit }) => {
    //     if (
    //       (minPrice === 0 || minPrice === null) &&
    //       (maxPrice === 0 || maxPrice === null) &&
    //       (minProfit === 0 || minProfit === null) &&
    //       (maxProfit === 0 || maxProfit === null)
    //     ) {
    //       self.setFiltered(false);
    //     }
    //   });
    // };
    const setMinPrice = val => {
      self.minPrice = val;
    };
    const setMaxPrice = val => {
      self.maxPrice = val;
    };
    const setMinProfit = val => {
      self.minProfit = val;
    };
    const setMaxProfit = val => {
      self.maxProfit = val;
    };
    const setProfitType = val => {
      self.profitType = val;
    };
    const InitFilterValue = key => {
      self[key] = null;
    };
    // const setFiltered = bool => {
    //   self.isFiltered = bool;
    // };
    const InitFilters = () => {
      self.profitType = 1;
      self.minPrice = null;
      self.maxPrice = null;
      self.minProfit = null;
      self.maxProfit = null;
      // self.isFiltered = false;
    };
    return {
      setMinPrice,
      setMaxPrice,
      setMinProfit,
      setMaxProfit,
      setProfitType,
      InitFilterValue,
      InitFilters,
      // setFiltered,
      // afterCreate,
    };
  });

export default Filters;
